/* eslint-disable @typescript-eslint/no-unused-vars */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global document, Office, console */
/* documentation https://typescript-toastify.vercel.app/ */

import "react-toastify/dist/ReactToastify.css";
import { AccountManager } from "../../../taskpane/authConfig";
import { getResolveURL } from "../../Scripts/resolveURL";
import "./Home2.css";
import { makeSecured2FetchRequest, servicecallsave, servicecallsecurity } from "../../../taskpane/wscall-helper";
import {
  makeGraphRequest,
  getToRecipients,
  getCCRecipients,
  getBCCRecipients,
  getFromRecipients,
  getBodyMessage,
  setBodyMessage,
  setSubject,
  resetSubject,
} from "../../../taskpane/msgraph-helper";
import {
  setGlobalconst,
  appendGlobalconst,
  getGlobalconst,
  showNotification,
  dumpdebug,
  convertToDateAndFormat,
  formatStandardUserErrorMessage,
  formatStandardSystemErrorMessage,
} from "../../../taskpane/utiltyfunctions";
import {
  PROPTRACE,
  EXPERIENCED_USER_MIN_EMAILS,
  PROPERRORTRACE,
  PROPSUBJECT,
  PROPBODYCONTENT,
  PROPBODYTYPE,
  PROPTOEMAIL,
  PROPCCEMAIL,
  PROPBCCEMAIL,
  PROPCALLBACKTOKEN,
  NOTIF_FAIL,
  PROPFROMEMAIL,
  PROPMAILID,
  PROPEMAILUNIQUEID,
  PROPJWTTOKEN,
  PROPLOCKTEMPLATE,
  PROPMESSAGETEMPLATE,
  stndseperatorstart,
  stndseperatorend,
  NOTIF_SUCCESS,
  TemplateVO,
  TemplateItem,
  OutlookVO,
  Subscription,
  defaultContent,
} from "../../../taskpane/globalconstants";

const sideloadMsg = document.getElementById("sideload-msg");
const appBody = document.getElementById("app-body");
const showTemplatesButton = document.getElementById("templates-link");
const okTemplatesButton = document.getElementById("templates-ok");
const cancelTemplatesButton = document.getElementById("templates-cancel");

const showSubscriptionButton = document.getElementById("subscription-link");
const subscriptionBackButton = document.getElementById("subscription-back");

const templateConfirmOkButton = document.getElementById("templates-confirmation-ok");
const templateConfirmCancelButton = document.getElementById("templates-confirmation-cancel");

const debugdataElement = document.getElementById("debugdata");
const secureEmailButton = document.getElementById("secure-email");
const revertEmailButton = document.getElementById("revert-email");
const accountManager = new AccountManager();

// Property keys.
var SUBSCRIPTION_ACTIVE: boolean = false;
var conversionStarted;
var experiencedUser: boolean = false;
var GPROCESS: string = "0";

// Define a type for key-value pair
type KeyValuePair = {
  key: string;
  value: string;
};

// Initialize when Office is ready.
Office.onReady((info: { host: any }) => {
  if (info.host === Office.HostType.Outlook) {
    if (sideloadMsg) sideloadMsg.style.display = "none";
    if (appBody) appBody.style.display = "flex";

    // Convert message
    if (secureEmailButton) {
      secureEmailButton.addEventListener("click", convertEmailMessage);
    }

    //Revert text button
    if (revertEmailButton) {
      revertEmailButton.addEventListener("click", resetBody);
    }

    // show the templates on request
    if (showTemplatesButton) {
      showTemplatesButton.addEventListener("click", showTemplates);
    }

    // Cancel Templates Button return to original view
    if (cancelTemplatesButton) {
      cancelTemplatesButton.addEventListener("click", showMain);
    }

    // Ok Template button, select a new teamplate.
    if (okTemplatesButton) {
      // TO-DO
      okTemplatesButton.addEventListener("click", showTemplatesConfirmation);
    }

    // Ok Templates Confirm Button
    if (templateConfirmOkButton) {
      templateConfirmOkButton.addEventListener("click", selectTemplate);
    }

    // Cancel Templates Confirm Button
    if (templateConfirmCancelButton) {
      templateConfirmCancelButton.addEventListener("click", showTemplates);
    }

    // Click on subscriptions
    if (showSubscriptionButton) {
      showSubscriptionButton.addEventListener("click", showSubscription);
    }

    // Click on subscriptions
    if (subscriptionBackButton) {
      subscriptionBackButton.addEventListener("click", showMain);
    }

    okTemplatesButton;
  }
});

// init the load screen
initglobalconstiables();

function initglobalconstiables() {
  setGlobalconst(PROPTRACE, "");
  setGlobalconst(PROPERRORTRACE, "");
  setGlobalconst(PROPSUBJECT, "");
  setGlobalconst(PROPBODYCONTENT, "");
  setGlobalconst(PROPBODYTYPE, "");
  setGlobalconst(PROPTOEMAIL, "");
  setGlobalconst(PROPCCEMAIL, "");
  setGlobalconst(PROPBCCEMAIL, "");
  setGlobalconst(GPROCESS, "0");
  // init all load screen work
  initializeMessage();
}

/**
 * Gets the user data such as name and email and displays it
 * in the task pane.
 */
async function initializeMessage() {
  try {
    // get the informaiton on the current logged in user    // Initialize MSAL.
    await accountManager.initialize();

    // refresh the access token and the user account information.
    const userObject: Object = await refeshUserInformtion();

    //initialize all application for new screen load.
    const subscriptionVO = await setMailItemIdAction(getGlobalconst(PROPCALLBACKTOKEN));

    loadSubscription(subscriptionVO);
  } catch (error) {
    var description = "Secured2 initializeMessage Experienced Error.  Return:" + error;
    appendGlobalconst(PROPERRORTRACE, description, stndseperatorstart, stndseperatorend);
    appendGlobalconst(PROPTRACE, description, stndseperatorstart, stndseperatorend);
    showNotification(NOTIF_FAIL, "Error - " + description);
    showoriginalstate();
  }
}

async function refeshUserInformtion(): Promise<Object> {
  // get the accesss token informaiton on the current logged in user    // Initialize MSAL.
  const accessToken = await accountManager.ssoGetAccessToken(["user.read"]);
  setGlobalconst(PROPCALLBACKTOKEN, accessToken);

  // Make the call to Graph.
  const response: any = await makeGraphRequest(accessToken, "/me", "");
  getFromRecipients();

  return response;
}

async function setMailItemIdAction(accessToken: string): Promise<any> {
  return new Promise((resolve, reject) => {
    Office.context.mailbox.item.saveAsync((result: any) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        setGlobalconst(PROPMAILID, result.value);
        //wait for the service call to complete and then send back on the resolve.
        resolve(servicecallsecurity(accessToken));
      } else {
        var description = "Token retrieval failed with message: ${result.error.message}";
        appendGlobalconst(PROPERRORTRACE, description, stndseperatorstart, stndseperatorend);
        return undefined;
      }
    });
  });
}

async function loadSubscription(subscriptionVO: any): Promise<any> {
  // get the subscription data
  dumpdebug("TRACE", "IF-1 getSubscription");

  // ensure there is a empty object at least for the subscription
  if (!subscriptionVO.subscription) {
    subscriptionVO.subscription = {} as Subscription;
  }

  var isSubscriptionTrial: boolean = false;
  if (subscriptionVO.subscription.active) {
    isSubscriptionTrial = subscriptionVO.subscription.active;
  }

  // determines if you have an active subscription.
  isSubscriptionTrial = subscriptionVO.subscription.startDate == null;
  var isSubscriptionActive = (SUBSCRIPTION_ACTIVE = subscriptionVO.subscription.active);

  //determines the number of free emails left.
  experiencedUser = subscriptionVO.subscription.emailCounter >= EXPERIENCED_USER_MIN_EMAILS;
  let trialRemainCount = EXPERIENCED_USER_MIN_EMAILS - subscriptionVO.subscription.emailCounter;

  //force remove after testing
  //trialRemainCount = 8;
  //isSubscriptionActive = false;

  //if trials remain and not a valid subscription
  if (trialRemainCount && !isSubscriptionActive) {
    // trial button if subscription does not exist
    const trialTypeElement = document.getElementById("trial-type");
    if (trialTypeElement) {
      var typeValue: string = subscriptionVO.type;
      if (typeValue !== undefined) {
        trialTypeElement.innerHTML = subscriptionVO.type.toLowerCase();
      }
    }
    const trialValueElement = document.getElementById("trial-value");
    if (trialValueElement) {
      trialValueElement.innerHTML = (subscriptionVO.remainingFreeTrial * subscriptionVO.totalTrial).toString();
    }

    const trialElement = document.getElementById("trial");
    if (trialElement) {
      trialElement.hidden = false;
    }

    const subscriptionLabelElement = document.getElementById("subscription-trial-label");
    if (subscriptionLabelElement) {
      subscriptionLabelElement.innerHTML = "Subscribe";
    }

    if (!isSubscriptionActive) {
      let htmltrialnotice;
      if (trialRemainCount > 0) {
        htmltrialnotice = "You have " + trialRemainCount.toString() + " remaining Free usages";
      } else {
        htmltrialnotice = "You're trial account has ended, please click on SUBSCRIPTION to enroll";
      }
      htmltrialnotice += "</br>Click SUBSCRIPTION to enroll now.";
      const trialRemainElement = document.getElementById("trial-remain");
      if (trialRemainElement) {
        trialRemainElement.innerHTML = htmltrialnotice;
      }
    }
    // Allways show the button if in trial mode.
    const trialSubscriptionLink = document.getElementById("subscription-trial-link");
    if (trialSubscriptionLink) {
      trialSubscriptionLink.hidden = false;
      //trialSubscriptionLink.innerText = Office.context.mailbox.userProfile.emailAddress;
      trialSubscriptionLink.addEventListener("click", showSubscription);
    }
  } else {
    // subscription exists
    const trialElement = document.getElementById("trial");
    if (trialElement) {
      trialElement.hidden = true;
    }

    const subscriptionLabelElement = document.getElementById("subscription-label");
    if (subscriptionLabelElement) {
      subscriptionLabelElement.innerHTML = "Subscription";
    }

    const subscriptionInfoElement = document.getElementById("subscription-info");
    if (subscriptionInfoElement) {
      subscriptionInfoElement.innerHTML =
        "You have " +
        (isSubscriptionActive == true ? "active " : "expired ") +
        (subscriptionVO.individual ? "(personal) " : "(corporate)") +
        "subscription:" +
        "<br/>Start date: " +
        convertToDateAndFormat(subscriptionVO.subscription.startDate, "MM/dd/yyyy h:mm:ss tt") +
        "<br/>End date: " +
        convertToDateAndFormat(subscriptionVO.subscription.endDate, "MM/dd/yyyy h:mm:ss tt") +
        "<br/>Paid date: " +
        convertToDateAndFormat(subscriptionVO.subscription.paidDate, "MM/dd/yyyy h:mm:ss tt");
    }

    const subscripotionCancelElement = document.getElementById("subscription-cancel");
    const subscripotionPayElement = document.getElementById("subscription-pay");
    if (isSubscriptionActive) {
      if (subscripotionCancelElement) {
        subscripotionCancelElement.hidden = false;
      }
      if (subscripotionPayElement) {
        subscripotionPayElement.hidden = true;
      }
    } else {
      if (subscripotionCancelElement) {
        subscripotionCancelElement.hidden = true;
      }
      if (subscripotionPayElement) {
        subscripotionPayElement.hidden = false;
      }
    }
  }
  // swutcg buttons
  loadTemplates("lock");
  loadAdditionalTemplates("email");
  // after getting all the templates.  Show the original state again.
  showoriginalstate();
  //showSplash();
}

async function loadTemplates(templatetype: string) {
  dumpdebug("TRACE", "Start getTemplates call");
  appendGlobalconst(PROPTRACE, "About to call getTemplates", stndseperatorstart, stndseperatorend);

  const queryParams: { [key: string]: string } = {
    email: encodeURIComponent(Office.context.mailbox.userProfile.emailAddress),
    type: templatetype,
  };
  //const queryParams = new URLSearchParams(params).toString();

  try {
    var uri = await getResolveURL("URLTEMPLATE");
    const respdata: TemplateVO = await makeSecured2FetchRequest(
      getGlobalconst(PROPCALLBACKTOKEN),
      getGlobalconst(PROPJWTTOKEN),
      uri,
      queryParams
    );

    //const lockTemplate: string = respdata.lockTemplate;

    if (respdata && respdata.items) {
      var found: boolean = false;
      respdata.items.forEach((item: TemplateItem, index: number) => {
        console.log(`Index: ${index}, Value: ${item.name}`);
        if (templatetype == "lock" && !found) {
          setGlobalconst(PROPLOCKTEMPLATE, item.id);
          found = true;
        } else {
          populateTemplates(item);
          if (showTemplatesButton) {
            showTemplatesButton.hidden = false;
          }

          found = true;
        }
        //var test: string = item.name;
        //var test2: string = item.template;
      });
      if (!found) {
        throw new Error("Secured2 getTemplates Experienced Error. No Lock Template Found");
      }
    } else {
      throw new Error("Secured2 getTemplates Experienced Error. No response");
    }
  } catch (error) {
    var description = "Secured2 getTemplates Experienced Error.  Return:" + error;
    appendGlobalconst(PROPERRORTRACE, description, stndseperatorstart, stndseperatorend);
    appendGlobalconst(PROPTRACE, description, stndseperatorstart, stndseperatorend);
    showNotification(NOTIF_FAIL, "Error - " + description);
    throw new Error(description);
  }
}

function loadAdditionalTemplates(templateType: string) {
  loadTemplates("email");
}

function populateTemplates(item: TemplateItem) {
  if (item) {
    const templateTableElement = document.getElementById("templates-table");
    if (templateTableElement) {
      // Create a new <tr> element
      const newRow = document.createElement("tr");

      // Create and append <td> elements to the new <tr>
      const cell1 = document.createElement("td");

      const radioButton = document.createElement("input");
      radioButton.type = "radio";
      radioButton.value = item.id.toString();
      radioButton.name = "template";
      radioButton.checked = true;
      cell1.append(radioButton);
      newRow.appendChild(cell1);

      const cell2 = document.createElement("td");
      cell2.textContent = item.name;
      newRow.appendChild(cell2);

      const cell3 = document.createElement("td");
      cell3.textContent = item.version;
      newRow.appendChild(cell3);

      const cell4 = document.createElement("td");
      cell4.textContent = convertToDateAndFormat(item.date, "MM/dd/yyyy");
      newRow.appendChild(cell4);

      // Append the new <tr> to the <tbody>
      templateTableElement.appendChild(newRow);
    }

    const templateLinkElement = document.getElementById("templates-link");
    if (templateLinkElement) {
      templateLinkElement.hidden = false;
    }
  }
}

function showTemplates() {
  const stepMainElement = document.getElementById("step-main");
  if (stepMainElement) {
    stepMainElement.hidden = true;
  }
  const stepTemplatesConfirmationElement = document.getElementById("step-templates-confirmation");
  if (stepTemplatesConfirmationElement) {
    stepTemplatesConfirmationElement.hidden = true;
  }
  const stepunsubscriptionElement = document.getElementById("step-unsubscription");
  if (stepunsubscriptionElement) {
    stepunsubscriptionElement.hidden = true;
  }
  const steptemplatesElement = document.getElementById("step-templates");
  if (steptemplatesElement) {
    steptemplatesElement.hidden = false;
  }
}

function showMain() {
  const steptemplatesElement = document.getElementById("step-templates");
  if (steptemplatesElement) {
    steptemplatesElement.hidden = true;
  }

  const stepTemplatesConfirmationElement = document.getElementById("step-templates-confirmation");
  if (stepTemplatesConfirmationElement) {
    stepTemplatesConfirmationElement.hidden = true;
  }

  const stepsubscriptionElement = document.getElementById("step-subscription");
  if (stepsubscriptionElement) {
    stepsubscriptionElement.hidden = true;
  }

  const stepunsubscriptionElement = document.getElementById("step-unsubscription");
  if (stepunsubscriptionElement) {
    stepunsubscriptionElement.hidden = true;
  }

  const stepMainElement = document.getElementById("step-main");
  if (stepMainElement) {
    stepMainElement.hidden = false;
  }

  const contentMainElement = document.getElementById("content-main");
  if (contentMainElement) {
    contentMainElement.setAttribute("top", "115px;");
  }

  const contentBodyElement = document.getElementById("content-body");
  if (contentBodyElement) {
    const paragraph1 = document.createElement("p");
    paragraph1.textContent = "The easy way to secure your email beyond encryption!";
    contentBodyElement.appendChild(paragraph1);

    const ul1Element = document.createElement("ul");
    const li1Element = document.createElement("li");
    li1Element.textContent = "Enter email(s) and compose your email";
    ul1Element.appendChild(li1Element);

    const li2Element = document.createElement("li");
    li2Element.textContent = "Click 'Secure Email' (you can click revert to edit after it's secure)";
    ul1Element.appendChild(li2Element);

    const li3Element = document.createElement("li");
    li3Element.textContent = "Attach a file(unlimited attachment size)";
    ul1Element.appendChild(li3Element);

    const li4Element = document.createElement("li");
    li4Element.textContent = "Hit send!</subscription-back>";
    ul1Element.appendChild(li4Element);

    contentBodyElement.append(ul1Element);
  }
}

/**
 * All functions past this are for actions.  Prior to this is the load of the screen.
 * ConverEmailMessage will run when the green button is hit.
 */
async function convertEmailMessage() {
  try {
    const userDataElement = document.getElementById("userData");
    // Specify minimum scopes for the token needed.

    const accessToken = await accountManager.ssoGetAccessToken(["user.read"]);
    setGlobalconst(PROPCALLBACKTOKEN, accessToken);

    // get all the to/from/bcc/cc
    const contactresult = await getContacts();

    const bodyContet: any = await getBodyMessage();

    if (typeof getGlobalconst(PROPTOEMAIL) == "undefined" || getGlobalconst(PROPTOEMAIL) == "") {
      showNotification(
        NOTIF_FAIL,
        "Email must contain at least one 'TO' email destination, please correct and resubmit."
      );
      return;
    }

    if (typeof getGlobalconst(PROPFROMEMAIL) == "undefined" || getGlobalconst(PROPFROMEMAIL) == "") {
      showNotification(NOTIF_FAIL, "System error determiming 'FROM', please correct and resubmit.");
      return;
    }

    if (typeof getGlobalconst(PROPBODYCONTENT) == "undefined" || getGlobalconst(PROPBODYCONTENT) == "") {
      showNotification(NOTIF_FAIL, "Email must conain a message to be secured, please create a message and resubmit.");
      return;
    }

    await servicecallsecurity(accessToken);

    const saveresult: any = await servicecallsave(accessToken, "MAIN", bodyContet);
    //  appendGlobalVar(PROPTRACE, "processsave Final and No Error",
    //      stndseperatorstart, stndseperatorend);
    //  app
    //      .showNotification(
    //          NOTIF_SUCCESS,
    //          "Email has been safely secured, please hit send when ready to send. Please lock the message again if you change To/Cc/Bcc/Subj fields!");

    if (debugdataElement) {
      debugdataElement.innerText = "Done with storage :)";
    }

    // set the subject of the email.
    const subresult = await setSubject();

    // set the body
    const subjectresult = setBody(false);
  } catch (error) {
    let sysdescription = formatStandardSystemErrorMessage("Convert Email", "Convert Email Experienced an Error", error);

    appendGlobalconst(PROPERRORTRACE, sysdescription, stndseperatorstart, stndseperatorend);
    appendGlobalconst(PROPTRACE, sysdescription, stndseperatorstart, stndseperatorend);

    const userdescription = formatStandardUserErrorMessage("Convert Email", "");
    showNotification(NOTIF_FAIL, userdescription);
  }
}

async function getContacts() {
  try {
    const toRec = await getToRecipients();
    const fromRec = await getFromRecipients();
    const ccRec = await getCCRecipients();
    const bccRec = await getBCCRecipients();
    return 0;
  } catch (error) {
    var description = "Secured2 getTemplates Experienced Error.  Return:" + error;
    appendGlobalconst(PROPERRORTRACE, description, stndseperatorstart, stndseperatorend);
    appendGlobalconst(PROPTRACE, description, stndseperatorstart, stndseperatorend);
    showNotification(NOTIF_FAIL, "Error - " + description);
    showoriginalstate();
    return -1;
  }
}

async function setBody(isTemplate: boolean) {
  appendGlobalconst(PROPTRACE, "setBodyURL", stndseperatorstart, stndseperatorend);
  dumpdebug("TRACE", "Start setBodyURL");
  var description = "";

  let resolveTemplate = "0";
  if (isTemplate) {
    resolveTemplate = getGlobalconst(PROPMESSAGETEMPLATE);
  } else {
    resolveTemplate = getGlobalconst(PROPLOCKTEMPLATE);
  }

  const queryParams: { [key: string]: string } = {
    emailid: resolveTemplate ? resolveTemplate : "0",
    linkqryparms: "utype=email&amp;id=" + getGlobalconst(PROPEMAILUNIQUEID),
    domainURL: getResolveURL("DOMAINONLY"),
    format: "json",
  };

  try {
    var uri = await getResolveURL("URLGETEMAIL");
    const respdata: OutlookVO = await makeSecured2FetchRequest(
      getGlobalconst(PROPCALLBACKTOKEN),
      getGlobalconst(PROPJWTTOKEN),
      uri,
      queryParams
    );

    if (respdata.result != 0) {
      description = "Secured2 Security Experienced Error.  Return:" + respdata.result + " Error:" + respdata.trace;
      appendGlobalconst(PROPERRORTRACE, description, stndseperatorstart, stndseperatorend);
      appendGlobalconst(PROPTRACE, description, stndseperatorstart, stndseperatorend);
      showNotification(NOTIF_FAIL, "Secured2 Error " + description);
    } else {
      dumpdebug("TRACE", "successfully returned HTLM email contents");
      var emailText = respdata.resultIdentifier;
      const result = await setBodyMessage(emailText);
      if (result == 0) {
        if (!isTemplate) {
          showfinalstate();
        }
      } else {
        throw Error("Issue with getting template try again");
      }
    }
  } catch (error) {
    description = "Secured2 Security Experienced Error.  Return: Error:" + error;
    appendGlobalconst(PROPERRORTRACE, description, stndseperatorstart, stndseperatorend);
    appendGlobalconst(PROPTRACE, description, stndseperatorstart, stndseperatorend);
    showNotification(NOTIF_FAIL, "Secured2 Error " + description);
  } // end of try/Catch.
}

async function resetBody() {
  if (revertEmailButton) {
    resetSubject();
    setBodyMessage(getGlobalconst(PROPBODYCONTENT));
    showoriginalstate();
  }
}

async function flipconvertButtons(showConvert: boolean) {
  if (revertEmailButton && secureEmailButton) {
    if (showConvert) {
      if (secureEmailButton.classList.contains("button-disabled")) {
        secureEmailButton.classList.remove("button-disabled");
      }
      revertEmailButton.classList.add("button-disabled");
    } else {
      if (revertEmailButton.classList.contains("button-disabled")) {
        revertEmailButton.classList.remove("button-disabled");
      }
      secureEmailButton.classList.add("button-disabled");
    }
  }
}

function showoriginalstate() {
  const dzButtonElement = document.getElementById(".dz-button");
  if (dzButtonElement) {
    dzButtonElement.innerHTML =
      '<img src="../../Images/upload.png" alt="Upload File"></br><span style = "color: #4285F4;font-weight: bold;">Please secure message prior to adding attachments</span>';
  }

  const convertStatusElement = document.getElementById("convert-status");
  if (convertStatusElement) {
    //convertStatusElement.innerHTML = circlenotdoneundertext;
  }

  var boxContainerElement = document.getElementById("box-container");
  if (boxContainerElement) {
    boxContainerElement.style.backgroundColor = "#8b898a;";
  }

  //Flip buttons
  flipconvertButtons(true);
}

function showfinalstate() {
  const dzButtonElement = document.getElementById(".dz-button");
  if (dzButtonElement) {
    dzButtonElement.innerHTML =
      '<img src="../../Images/upload.png" alt="Upload File"></br><span style = "color: #4285F4;font-weight: bold;">Drop Files Here to Upload</span>';
  }

  const convertStatusElement = document.getElementById("convert-status");
  if (convertStatusElement) {
    //convertStatusElement.innerHTML = circlenotdoneundertext;
  }

  var boxContainerElement = document.getElementById("box-container");
  if (boxContainerElement) {
    boxContainerElement.style.backgroundColor = "#0F9D58;";
  }

  //Flip buttons
  flipconvertButtons(false);
  showNotification(NOTIF_SUCCESS, " Secure Message ");
}

function showSplash() {
  // var speed = experiencedUser ? 1000 : 45;
  var speed = experiencedUser ? 4 : 45;

  var bodyElement = document.getElementById("body");
  if (bodyElement) {
    bodyElement.hidden = false;
  }
  // drawing the progress bar timer
  //var progressbar = $("#progressbar").progressbar({
  //  value: 100,
  //});
}

function showSubscription() {
  var contentMainElement = document.getElementById("content-main");
  if (contentMainElement) {
    contentMainElement.style.top = "115px";
  }

  var contentBody = document.getElementById("content-body");
  if (contentBody) {
    contentBody.innerHTML = "<h2>Subscription Details</h2>";
  }

  var stepMain = document.getElementById("step-main");
  if (stepMain) {
    stepMain.hidden = true;
  }

  var stepSubscription = document.getElementById("step-subscription");
  if (stepSubscription) {
    stepSubscription.hidden = false;
  }

  var stepUnsubscribe = document.getElementById("step-unsubscription");
  if (stepUnsubscribe) {
    stepUnsubscribe.hidden = true;
  }
}

function showTemplatesConfirmation() {
  Office.cast.item.toItemCompose(Office.context.mailbox.item).body.getTypeAsync(function (result: any) {
    setGlobalconst(PROPBODYTYPE, result.value);
    Office.cast.item.toItemCompose(Office.context.mailbox.item).body.getAsync(
      result.value,
      {
        asyncContext: "This is passed to the callback",
      },
      function callback(result: any) {
        setGlobalconst(PROPBODYCONTENT, result.value);
        if (result.value != defaultContent) {
          var stepmain = document.getElementById("step-main");
          if (stepmain) {
            stepmain.hidden = true;
          }

          var steptemplate = document.getElementById("step-templates");
          if (steptemplate) {
            steptemplate.hidden = true;
          }

          var steptemplateConfirm = document.getElementById("step-templates-confirmation");
          if (steptemplateConfirm) {
            steptemplateConfirm.hidden = false;
          }
        } else {
          selectTemplate();
        }
      }
    );
  });
}

function selectTemplate() {
  showMain();
  var templateTable = document.getElementById("templates-table");

  if (templateTable) {
    const selectedRadio = templateTable.querySelector('input[name="template"]:checked');
    if (selectedRadio) {
      const selectRadioValue: string = selectedRadio.value;
      setGlobalconst(PROPMESSAGETEMPLATE, selectRadioValue);
    }
    setBody(true);
  }
}

function getUserFiles(this: HTMLElement, ev: MouseEvent) {
  throw new Error("Function not implemented.");
}
